<template>
  <div class="block">
    <el-tabs v-model="activeName">
      <el-tab-pane label="待结佣" name="first">
        <unpaid-commission :activeName="activeName" v-if="activeName === 'first'"></unpaid-commission>
      </el-tab-pane>
      <el-tab-pane label="已结佣" name="second">
        <already-engaged :activeName="activeName" v-if="activeName === 'second'"></already-engaged>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import AlreadyEngaged from "./AlreadyEngaged";
import UnpaidCommission from "./UnpaidCommission";

export default {
  components: {
    AlreadyEngaged,
    UnpaidCommission,
  },
  data() {
    return {
      activeName: "first",
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/kuaishou/distribution/settle.vue